(function () {
  var ACCOUNTS_HOST = "accounts.audiomediagrading.com";
  var COOKIE_NAME = "amg_cart_count";

  function setCartCookie(count) {
    document.cookie =
      COOKIE_NAME +
      "=" +
      (count || 0) +
      "; domain=.audiomediagrading.com; path=/; max-age=600; SameSite=Lax; Secure";
  }

  function syncCartCookie() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        setCartCookie(cart.item_count || 0);
        return cart.item_count || 0;
      })
      .catch(function () {
        return 0;
      });
  }

  function appendCartToAccountsLinks(count) {
    document.querySelectorAll('a[href*="' + ACCOUNTS_HOST + '"]').forEach(function (a) {
      try {
        var url = new URL(a.href);
        if (url.hostname.indexOf(ACCOUNTS_HOST) === -1) return;
        url.searchParams.set("amg_cart", String(count));
        a.href = url.toString();
      } catch (e) {}
    });
  }

  syncCartCookie().then(function (count) {
    appendCartToAccountsLinks(count);
  });

  document.addEventListener("cart:updated", function () {
    syncCartCookie();
  });

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") syncCartCookie();
  });
})();
